<template>
<m-pageframe
    title="{organization-label}: Forms"
>
<v-container
    fluid
    style="padding: 15px"
>

    <v-text-field
        autocomplete="off"
        label="Search"
        prepend-icon="mdi-magnify"
        v-model="full_text"
        v-on:input="update"
    >
        <v-menu
            bottom
            offset-y
            slot="append-outer"
        >
            <template v-slot:activator="{ on }">
                <v-icon
                    v-on="on"
                >
                    mdi-dots-vertical
                </v-icon>
            </template>
    
            <v-list>
                <v-list-item
                    v-on:click="onClickAdd('opt-in')"
                >
                    <v-list-item-title>New form...</v-list-item-title>
                </v-list-item>

                <!-- This has been intentionally been made the same as clicking New Form... (this was a request Jennie made to limit customer confusion for customers wanting to create an opt-in form)-->
                <v-list-item
                    v-on:click="onClickAdd('opt-in')"
                >
                    <v-list-item-title>New opt-in form...</v-list-item-title>
                </v-list-item>

                 <v-list-item
                    v-on:click="onClickAdd('payment-card-on-file')"
                >
                    <v-list-item-title>New payment form (update card on file)...</v-list-item-title>
                </v-list-item>
                <v-list-item
                    v-on:click="onClickAdd('payment-one-time')"
                >
                    <v-list-item-title>New payment form (one time purchase)...</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu> 
    </v-text-field>

    <m-boolean-search-filter
        style="margin-top: 5px; margin-left: 10px;"
        label="Archived"
        v-model="filter_archived"
        v-on:input='doUpdate'
    />

    <v-data-table
        v-if="results != null"
        :headers="headers"
        :items="results"
        :items-per-page="100"
        class="elevation-1"
        :hide-default-footer="true"
        disable-sort
        :footer-props="{
            disableItemsPerPage: false,
            disablePagination: false,
        }"
    >
        <template v-slot:item.is_archived="{ item }">
            <v-simple-checkbox v-model="item.is_archived" disabled></v-simple-checkbox>
        </template>
    
        <template v-slot:item.action="{ item }">
            <v-menu 
                bottom 
                offset-y  
            >
            
            <template v-slot:activator="{ on }">
                    
                <v-icon 
                    v-on="on"
                >
                    mdi-dots-vertical-circle-outline
                </v-icon>
                    
            </template>
            
            <v-list>
                <v-list-item
                    v-on:click="onClickEdit(item)"
                >
                    <v-list-item-title>Edit...</v-list-item-title>
                </v-list-item>

                <v-divider/>

                <v-list-item
                    v-on:click="onClickExport(item)"
                >
                    <v-list-item-title>Export form submissions...</v-list-item-title>
                </v-list-item>

                <v-divider/>

                <v-list-item
                    v-on:click="onClickToggleArchive(item)"
                >
                    <v-list-item-title v-if="item.is_archived">Un-archive...</v-list-item-title>
                    <v-list-item-title v-if="!item.is_archived">Archive...</v-list-item-title>
                </v-list-item>

                <v-list-item
                    v-on:click="onClickDuplicate(item)"
                >
                    <v-list-item-title>Duplicate...</v-list-item-title>
                </v-list-item>
            
            </v-list>
            
            </v-menu> 
        </template>
    
    </v-data-table>

</v-container>
</m-pageframe>
</template>

<script>
const _ = require('lodash');

export default {
    data() {
        return {
            results: [],
            full_text: null,
            filter_archived: false,

            headers: [
                { text: 'Name', value: 'internal_label'},
                { text: 'Submission Count', value: 'submission_count'},
                { text: 'Archived', value: 'is_archived'},
                { text: 'Action', value: 'action'},
            ],
        }
    },

    mounted () {
        this.doUpdate();
    },

    methods: {
        update: _.debounce(function(){
            this.doUpdate();
        }, 751),
        
        doUpdate()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'LIST: /api/v1/forms',
            
                'params' : {
                        'organization_id' : this.$route.params.organization_id,
                        'full_text': this.full_text,
                        'is_archived': this.filter_archived,
                    },
            
                'on_success': (data) => {
                        this.results = data.results;
                    },
            
                'on_error': 'Unable to complete API call',
            });
        },

        onClickEdit(item)
        {
            this.$router.push({
                'name': 'edit-form',
                'params' : {
                    'form_id': item.form_id,
                }
            });
        },

        onClickDuplicate(item)
        {
            this.$rc.confirm({
                'title': 'Duplicate form',
                'body': 'Are you sure that you want to duplicate the form: '+item.internal_label,
                'btn_text_ok': 'Duplicate',
                'btn_text_cancel': 'No',
                'on_ok': () => {
                    this.doDuplicate(item);
                },
            });
        },

        doDuplicate(item)
        {
            this.$rc.rest({
                'spinner': true,
                'endpoint': 'PUT: /api/v1/forms/duplicate',
            
                'params' : {
                        'form_id': item.form_id
                    },
            
                'on_success': (data) => {
                        this.doUpdate();
                    },
            
                'on_error': 'Unable to duplicate form',
            });
        },

        onClickToggleArchive(item)
        {
            if ( item.is_archived ) 
            {
                this.doToggleArchived(item);
                return;
            }

            this.$rc.confirm({
                'title': 'Archive form',
                'body': 'Are you sure that you want to archive the form: '+item.internal_label,
                'btn_text_ok': 'Archive',
                'btn_text_cancel': 'No',
                'on_ok': () => {
                    this.doToggleArchived(item);
                },
            });
        },

        doToggleArchived(item)
        {
            this.$rc.rest({
                'spinner': true,
                'endpoint': 'PUT: /api/v1/forms/toggle-archived',
            
                'params' : {
                        'form_id': item.form_id
                    },
            
                'on_success': (data) => {
                        this.doUpdate();
                    },
            
                'on_error': 'Unable to archive / un-archive form',
            });
        },

        onClickAdd(type)
        {
            let title = 'New form name';
            let label = 'The name of the new form (internal only)';

            if ( type == 'payment-card-on-file' || type == 'payment-one-time' )
            {
                title = 'New payment form name';
                label = 'The name of the new payment form (internal only)';
            }

            this.$rc.prompt({
                'title' : title,
                'label' : label,
                'value' : null,
                'textarea' : false,
                'after_prompt' : (value) => {
                    
                    this.$rc.rest({
                        'spinner': true,
                        'endpoint': 'PUT: /api/v1/forms/create',
                    
                        'params' : {
                                'organization_id' : this.$route.params.organization_id,
                                'internal_label': value,
                                'type': type,
                            },
                    
                        'on_success': (data) => {
                                this.doUpdate();
                            },
                    
                        'on_error': 'Unable to create form',
                    });
                }
            });
        },

        onClickExport(item)
        {
            let form_id = item.form_id;

            this.$rc.excelExport(
                    'EXPORT: /api/v1/search-contact-requests/:in_organization_id',
                    {
                        'in_organization_id' : item.organization_id,
                        'organization_id' : item.organization_id,

                        'form_id': form_id
                    }
                );
        },
    },
}
</script>

<style lang="scss" scoped>
</style>